/**
 * Home 3 Page Banner
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class HomeBanner3 extends Component {

   render() {
    return (
        <div className="row">
            <div className="col-md-6">
            <div className="magasin_banner_wrapper ">
                <Link className="pgs_banner-link" to="/shop">
                <div className="magasin_banner magasin_banner-style-style-1 magasin_banner-effect-none ciya-banner-1"> <img className="magasin_banner-image img-fluid inline" alt="Banner" src={require(`../../assets/images/categories/modern/women.jpg`)}  />
                    <div className="magasin_banner-content magasin_banner-content-hcenter magasin_banner-content-vbottom">
                    <div className="magasin_banner-content-wrapper">
                        <div className="magasin_banner-content-inner-wrapper">
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-1 magasin_banner-text-bg_color hidden-lg hidden-md hidden-sm hidden-xs">
                            <div className="magasin_banner-text tag-text"> Women's collections</div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </Link>
            </div>
            </div>
            <div className="col-md-6 mt-4 mt-md-0">
            <div className="magasin_banner_wrapper ">
                <Link className="pgs_banner-link" to="/shop">
                <div className="magasin_banner magasin_banner-style-style-1 magasin_banner-effect-none ciya-banner-2"> <img className="magasin_banner-image img-fluid inline" alt="Banner" src={require(`../../assets/images/categories/modern/men.jpg`)}  />
                    <div className="magasin_banner-content magasin_banner-content-hcenter magasin_banner-content-vbottom">
                    <div className="magasin_banner-content-wrapper">
                        <div className="magasin_banner-content-inner-wrapper">
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-1 magasin_banner-text-bg_color">
                            <div className="magasin_banner-text tag-text"> Men's collections</div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </Link>
            </div>
            </div>
         </div>
      )
}
}

export default HomeBanner3;

